import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Row,
} from "react-bootstrap";
import { FaShoppingCart } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Typed from "react-typed";

import { RouteEnum } from "core/enum/route.enum";
import { useSelectIsAuthenticated } from "store/auth/auth.selectors";
import { useCartTotalCount } from "store/slices/cart/cart.selectors";
import { UseGetMenu } from "../../../core/services/api/get-menu";
import { correctUploadPath } from "../../../core/utils/image-path-correction";
import { showToast, ToastTypes } from "../../../core/utils/show-toast";
import TestNavbarMenu from "./TestNavbar/TestNavbar";

import "./TestHeader.scss";

const TestHeader = () => {
  const isAuthenticated = useSelectIsAuthenticated();
  const history = useHistory();

  const redirectToLogin = () => {
    showToast(["در حال انتقال به صفحه ورود"], ToastTypes.info);
    history.push(RouteEnum.Login);
  };
  const redirectToLogout = () => {
    showToast(["در حال خروج"], ToastTypes.info);
    history.push(RouteEnum.SignOut);
  };

  const state = useSelector((state) => state.setting);
  const linkIsValidRegex = /http/;
  const [linkIsValid, setLinkIsValid] = useState(false);

  useEffect(() => {
    setLinkIsValid(linkIsValidRegex.test(state.googleMapLink));
  }, [state]);
  const { data, isLoading, isError, isSuccess } = UseGetMenu();

  const cartCount = useCartTotalCount();

  return isSuccess ? (
    <>
      <header className="site-header ">
        <h6 className="typed-text">
          <Typed
            strings={[
              "به سامانه جامع بهره برداران کشاورزی خوش آمدید، شما می توانید با ثبت نام در این سامانه از خدمات مجمع هماهنگی اصناف کشاورزی استان مازندران بهره مند شوید .      ",
            ]}
            typeSpeed={50}
          />
        </h6>
        <Container fluid>
          <Row>
            <Col
              xs={6}
              sm={1}
              md={1}
              lg={1}
              className="d-flex justify-content-start logoBox "
            >
              <div className="site-logo">
                {state.logoImageAddress !== "" && (
                  <Link
                    style={{ color: "inherit", TextDecoration: "none" }}
                    to="/"
                  >
                    <img
                      alt="logo"
                      src={
                        process.env.REACT_APP_PUBLIC_PATH +
                        "/" +
                        correctUploadPath(state.logoImageAddress)
                      }
                    />
                  </Link>
                )}
              </div>
            </Col>

            <Col xs={6} sm={8} md={8} lg={8} className=" menu">
              <div className="navLink mt-3">
                <Link to={RouteEnum.Store}>فروشگاه</Link>
                <Link to={RouteEnum.ContactUs}>تماس با ما</Link>
                <Link to={RouteEnum.AboutUs}>درباره ما</Link>
                <Link to={RouteEnum.SiteRules}>قوانین و مقررات</Link>
              </div>

              <div className="navbarMenuBox ">
                <TestNavbarMenu data={data} />
              </div>
            </Col>

            <Col
              xs={2}
              sm={2}
              md={2}
              lg={2}
              className="d-flex justify-content-center SearchBox "
            >
              {/* <TestSearchBox /> */}
            </Col>

            <Col
              xs={1}
              sm={1}
              md={1}
              lg={1}
              className="d-flex justify-content-center  loginBox "
            >
              <Link
                className="cart-icon"
                style={{
                  position: "relative",
                  marginLeft: "15px",
                  marginTop: "11px",
                  cursor: "pointer",
                }}
                to={RouteEnum.Cart}
              >
                <FaShoppingCart size={22} color="white" />
                {cartCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                      background: "red",
                      color: "white",
                      fontSize: "10px",
                      padding: "3px 8px 1px 6px",
                      borderRadius: "50%",
                    }}
                  >
                    {cartCount}
                  </span>
                )}
              </Link>
              {isAuthenticated ? (
                <>
                  <DropdownButton
                    variant="#ffffff"
                    key="down-centered"
                    className="profile-dropdown User-features "
                    title="امکانات کاربری"
                  >
                    <div className="User-features-items">
                      {/* <Dropdown.Item href="#/action-1">
                        <Link
                          style={{
                            color: "black",
                            position: "relative",
                            right: "-40px",
                            fontSize: "12px",
                          }}
                          to="/wallet/charge"
                        >
                          درگاه پرداخت
                        </Link>
                      </Dropdown.Item> */}
                      <Dropdown.Item href="#/action-1">
                        <Link
                          style={{
                            color: "black",
                            position: "relative",
                            // right: "-40px",
                            fontSize: "12px",
                          }}
                          to={RouteEnum.Transaction}
                        >
                          تراکنش های من
                        </Link>
                      </Dropdown.Item>

                      <Dropdown.Item href="#/action-1">
                        <Link
                          style={{
                            color: "black",
                            position: "relative",
                            // right: "-40px",
                            fontSize: "12px",
                          }}
                          to={RouteEnum.UserOrders}
                        >
                          لیست سفارشات کاربر
                        </Link>
                      </Dropdown.Item>

                      {/* <Dropdown.Item href="#/action-1">
                        <Link
                          style={{
                            color: "black",
                            position: "relative",
                            right: "-40px",
                            fontSize: "12px",
                          }}
                          to="/Challenges/MyChallenges"
                        >
                          مشاهده صدا های من
                        </Link>
                      </Dropdown.Item> */}
                      {/* <Dropdown.Item
                        style={{
                          color: "black",
                          position: "relative",
                          right: "-40px",
                          fontSize: "12px",
                        }}
                        href="#/action-2"
                      >
                        <Link to="/Challenges/SignedChallenges">
                          مشاهده صدا های امضاء شده من
                        </Link>
                      </Dropdown.Item> */}
                      <Dropdown.Item href="#/action-3">
                        <Button
                          style={{
                            color: "white",
                            position: "relative",
                            left: "-60px",
                            fontSize: "12px",
                            backgroundColor: "red",
                            border: "0px none",
                            borderRadius: "25px",
                          }}
                          onClick={redirectToLogout}
                        >
                          خروج
                        </Button>
                      </Dropdown.Item>
                    </div>
                  </DropdownButton>
                </>
              ) : (
                <>
                  <Button
                    className="login mt-1"
                    onClick={redirectToLogin}
                    style={{}}
                  >
                    <p
                      className=""
                      style={{
                        display: "inline",
                        margin: 0,
                      }}
                    >
                      ورود
                    </p>
                  </Button>

                  {/* <a href="https://Register.sabak.org">
                      <Button className="register">
                        <div></div>ثبت نام
                        <img alt="avatar" src={SignUp} />
                      </Button>
                    </a> */}
                </>
              )}
            </Col>
          </Row>
        </Container>

        {/* <div className="site-logo">
            {state.logoImageAddress !== "" && (
              <Link style={{ color: "inherit", TextDecoration: "none" }} to="/">
                <img
                  alt="logo"
                  src={
                    process.env.REACT_APP_PUBLIC_PATH +
                    "/" +
                    correctUploadPath(state.logoImageAddress)
                  }
                />
              </Link>
            )}
          </div> */}
      </header>
    </>
  ) : (
    <></>
  );
};

export default TestHeader;
